
export const SET_DATABASE_DUMPS = 'databases/set-database-dump';
export const SET_DATABASE_INIT_BACKUP = 'databases/set-database-init-backup';
export const SET_DATABASE_STATUS_BACKUP = 'databases/set-database-status-backup';
export const SET_DATABASE_REPORT_BACKUP = 'databases/set-database-report-backup';
export const SET_DATABASE_DUMP_TABLE = 'databases/set-database-dump-table';
export const SET_DATABASE_DUMP_TABLE_DATA = 'databases/set-database-dump-table-data';
